class Slider {

    constructor(selector, settings, callback) {
        this.sets = {
            synced: null
        }
        this.data = {
            head: 0
        }

        this.settings = {...this.sets, settings};
        if (!this.data.hasOwnProperty('setHead')) {
            const that = this;
            Object.defineProperty(this.data, 'setHead', {
                set: function(i) {
                    this.head = that.calculateOffset(i);
                    that.handleUpdate(this.head);
                }, 
                get: function() {
                    return this.head;
                } 
            });
        }
        
        
        this.callback = (callback) ? callback : function(){};
        this.selectorItems = document.querySelectorAll(selector);
        
        this.selectorItems.forEach(selector => {
            const slides = selector.querySelectorAll('.slide');
            slides.forEach((item, i) => {
                item.addEventListener('click', () => {
                    this.changeSlide(i);
                });
            });
            this.total = (slides.length) ? slides.length : 0;
        });
        this.setupPagination();
        this.data.setHead = 1;
    }
    
    setupPagination() {
        const navigation = document.createElement('div');
        navigation.classList.add('slider__navigation');
        const template = document.createElement('ul');
        template.classList.add('slider__pagination');
        const prev = document.createElement('div');
        prev.classList.add('prev-arrow');
        const next = document.createElement('div');
        next.classList.add('next-arrow');
        prev.addEventListener('click', () => {
            this.decreaseSlide();
        });
        next.addEventListener('click', () => {
            this.increaseSlide();
        });
        
        for (let i = 0; i < this.total; i++) {
            const li = document.createElement('li');
            const button = document.createElement('button');
            li.appendChild(button);
            template.appendChild(li);
            button.addEventListener('click', () => {
                this.changeSlide(i);
            });
        }
        navigation.appendChild(prev);
        navigation.appendChild(template);
        navigation.appendChild(next);
        this.selectorItems[0].after(navigation);
    }
    
    autoplay(i = 0) {
        if (i < 500) {
            i++;
        } else {
            i = 0;
        }
        window.requestAnimationFrame(() => {
            this.autoplay(i)
        });
    }

    handleUpdate(head) {
        this.selectorItems.forEach(selector => {
            const slides = selector.querySelectorAll('.slide');
            slides.forEach((slide, i) => {
                debugger;
                slide.classList.remove('active');
                slide.classList.remove('nextSlide');
                slide.classList.remove('prevSlide');
                if (i == head) {
                    slide.classList.add('active')
                }
                if (i == this.calculateOffset(head + 1) ) {
                    slide.classList.add('nextSlide')
                }
                if (i == this.calculateOffset(head - 1) ) {
                    slide.classList.add('prevSlide')
                }
                
            });
        });
        
        console.log(document.querySelectorAll('.slider__pagination li'));
        document.querySelectorAll('.slider__pagination li').forEach((item, i) => {
            item.classList.remove('active');
            if (i == this.data.head) {
                item.classList.add('active');
            }
        })

    }

    calculateOffset(i) {
        let calculated = i
        if (i < 0) {
            calculated = this.total - 1;
        } else if ( i > this.total - 1) {
            calculated = 0
        } 
        return calculated;
    }

    changeSlide(i) {
        this.data.setHead = i;
        
    }
    
    increaseSlide() {
        this.changeSlide(this.data.head + 1);
    }
    
    decreaseSlide() {
        this.changeSlide(this.data.head - 1);
    }

}

export default Slider;